import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

//------------------------------------------------------------------------------

function ChatMessage(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { fromMe, text, sentBy } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function computeMessagePrefix() {
    if (sentBy) {
      return `${sentBy}: `
    } else {
      return ""
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const rowStyle = {
    justifyContent: fromMe ? "flex-end" : "flex-start",
  }

  return (
    <div className={props.className} style={rowStyle}>
      <div className="message">
        <b>{computeMessagePrefix()}</b> {text}
      </div>
    </div>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

ChatMessage.propTypes = {
  className: PropTypes.string.isRequired,
  fromMe: PropTypes.bool,
  text: PropTypes.string,
}

ChatMessage.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledChatMessage = styled(ChatMessage)`
  & {
    width: 100%;
    height: auto;

    display: flex;
    flex-direction: row;
    justify-content: ${(props) => (props.fromMe ? "flex-end" : "flex-start")};

    .message {
      padding: 10px 15px;

      max-width: 50%;

      border-radius: ${(props) =>
        props.fromMe ? "20px 20px 0 20px" : "20px 20px 20px 0"};

      background-color: ${(props) =>
        props.fromMe
          ? props.theme.colors.primaryColor
          : props.theme.colors.textSecondaryColor};

      color: ${(props) => props.theme.colors.textOnPrimary};
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledChatMessage
